/**
 * SalesOrderDetailPage types (S2.3) — section keys for the ?section=
 * deep-link (route-derived selection tenet) + the shared status Tag preset.
 */

import type { SalesOrderStatus } from '@/types/api/salesOrder';

export const SO_DETAIL_SECTION_KEYS = ['lines', 'checklist', 'audit'] as const;

export type SoDetailSectionKey = (typeof SO_DETAIL_SECTION_KEYS)[number];

/**
 * antd Tag preset per status (StatusTag precedent; no purple literal).
 * Mirrors SalesOrderListPage's map — hoist both into a shared soStatus
 * module when a third consumer appears (slice followUp).
 */
export const SO_STATUS_TAG_COLOR: Record<SalesOrderStatus, string> = {
  draft: 'default',
  confirmed: 'blue',
  converted_to_po: 'geekblue',
  shipped: 'cyan',
  invoiced: 'gold',
  paid: 'green',
};
